module.exports = __webpack_public_path__ + "img/Herrer.c8d5aa37.jpg";